import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import DataCompanies from "./CompaniesData";
import axios from "axios";
import { url } from "../../../Constant";
import { useEffect } from "react";
import { Dashboard, Edit, Information, View } from "@carbon/icons-react";
import { toast } from "react-toastify";
import { useAuth } from "../../../Context/AuthProvider";

const customStyles = {
  pagination: {
    style: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
};

const Companies = () => {
  const { auth } = useAuth();
  const [searchText, setSearchText] = useState("");
  const [loader, setLoader] = useState(false);
  const [companies, setCompanies] = useState();
  const [totalPages, setTotalPages] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [apicalled, setApicalled] = useState(false);

  const navigate = useNavigate();

  const columns = [
    {
      name: "COMPANY NAME",
      selector: "company_name",
      cell: (row) => <div className="fontColor">{row.company_name}</div>,
    },
    {
      name: "MASTER NO. DIOD",
      selector: "diodid",
      cell: (row) => <div className="fontColor">{row.diodid}</div>,
    },

    {
      name: "Packages",
      selector: "package_name",
      // cell: (row) => <div className="fontColor">{row.diodid}</div>,
    },
    {
      name: "USER",
      selector: "user_name",
    },
    {
      name: "EMAIL ADDRESS",
      selector: "email",
      cell: (row) => <div className="EmailWidth">{row.email}</div>,
    },
    {
      name: "WORK NUMBER",
      selector: "work_number",
    },
    // {
    //   name: "MOBILE NUMBERS",
    //   selector: "mobile_number",
    // },
    // {
    //   name: "Created",
    //   selector: "CREATED",
    // },

    {
      name: "STATUS",
      // selector: (row) => row.status,
      selector: (row) => (
        <div>
          {/* <button
            className={
              row.status === 1 ? "btn-design redColor" : "btn-design greenColor"
            }
            onClick={() => handleStatus(row.status, row.vpbx_id)}
          >
            {row.status === 1 ? "De-Activated" : "Activated"}
          </button> */}
          {row.status === 1 ? "Active" : "De-Activated"}
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <div className="">
          <div className="uk-inline">
            {/* <button
              className="iconTble actionDropDownBtn TableActionIcon"
              type="button"
              onClick={() => {
                sessionStorage.setItem("companyData", row.vpbx_id);
                window.location.href = `/edit-company`;
              }}
            > */}
              {/* <img src="./assets/images/zong/trash-can.svg" uk-svg="" alt="Delete" /> */}
              {/* <Edit />
            </button> */}
            {/* <button
              className="iconTble actionDropDownBtn TableActionIcon"
              type="button"
            >
              <img
                src="./assets/images/zong/trash-can.svg"
               uk-svg=""
                alt="Delete"
              />
            </button> */}
            <button
              className="iconTble actionDropDownBtn TableActionIcon"
              type="button"
              onClick={() => {
                sessionStorage.setItem("companyData", row.vpbx_id);
                sessionStorage.setItem("template_id", row.is_templete);
                window.location.href = `/call-records`;
              }}
              uk-tooltip="View Company"
            >
              <Dashboard />
            </button>
          </div>
        </div>
      ),
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newRowsPerPage, page) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(page);
  };
  const dataTableProps = {
    pagination: true,
    paginationServer: true,
    paginationTotalRows: totalPages,
    paginationDefaultPage: currentPage,
    paginationPerPage: rowsPerPage,
    paginationRowsPerPageOptions: [10, 15, 20, 25, 30],
    onChangePage: handlePageChange,
    onChangeRowsPerPage: handleRowsPerPageChange,
  };

  // const handleEditLayer = (row) => {
  //   // console.log("Row data:", row);
  //   navigate("/edit-layer", { state: { rowData: row } });
  // };

  useEffect(() => {
    getCompanies();
  }, [currentPage, searchText, rowsPerPage]);

  const handleSearchform = (event) => {
    setSearchText(event.target.value);
  };

  // const handleStatus = (Status, vpbx_id) => {
  //   setLoader(true);

  //   const newStatus = Status === 0 ? 1 : 0;
  //   const statusText = newStatus === 1 ? 'Activated' : 'Deactivated';

  //   axios
  //     .post(
  //       url + "change-company-status",
  //       {
  //         vpbx_id: vpbx_id,
  //         status: newStatus,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${auth.token}`,
  //         },
  //       }
  //     )
  //     .then(function (result) {
  //       if (result.data.status === true) {
  //         setLoader(false);
  //         toast.success(`Status ${statusText} Successfully`, {
  //           position: toast.POSITION.TOP_RIGHT,
  //           autoClose: 1200,
  //         });
  //         setTimeout(() => {
  //           window.location.href = "/vpbx-manager";
  //         }, 1500);
  //       }
  //     });
  // };

  useEffect(() => {
    if (companies !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)",
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [companies]);

  const handleStatus = (Status, vpbx_id) => {
    setLoader(true);

    const newStatus = Status === 0 ? 1 : 0;
    const statusText = newStatus === 1 ? "Activated" : "Deactivated";
    const toastType = newStatus === 1 ? "success" : "error"; // Determine toast type

    axios
      .post(
        url + "change-company-status",
        {
          vpbx_id: vpbx_id,
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(function (result) {
        if (result.data.status === true) {
          setLoader(false);

          if (toastType === "success") {
            toast.success(`Status ${statusText} Successfully`, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          } else {
            toast.error(`Status ${statusText} Successfully`, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }

          setTimeout(() => {
            window.location.href = "/companies";
          }, 1500);
        }
      });
  };

  const getCompanies = () => {
    setLoader(true);

    var data = {};
    data["page"] = currentPage;
    data["limit"] = rowsPerPage;
    data["search"] = searchText;

    axios
      .post(url + "get-companies", data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setApicalled(false);
            setLoader(false);

            if (
              response.data.message === "Data Not Found" &&
              response.data.data.companies.length === 0
            ) {
              setCompanies([]);
            } else if (response.data.message === "Data Found") {
              setCompanies(response.data.data.companies);
              setTotalPages(response.data.data.pages);
            }
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  useEffect(() => {
    if (apicalled === true) {
      getCompanies();
    }
  }, [apicalled]);

  useEffect(() => {
    if (auth.role !== "1") {
      window.location.href = "/";
    }
    getCompanies();
  }, []);

  const filteredDataCompanies = companies?.filter((CompaniesData) => {
    return (
      (CompaniesData.company_name &&
        CompaniesData.company_name
          .toLowerCase()
          .includes(searchText.toLowerCase())) ||
      (CompaniesData.diodid &&
        CompaniesData.diodid
          .toLowerCase()
          .includes(searchText.toLowerCase())) ||
      (CompaniesData.package_name &&
        CompaniesData.package_name
          .toLowerCase()
          .includes(searchText.toLowerCase())) ||
      (CompaniesData.user_name &&
        CompaniesData.user_name
          .toLowerCase()
          .includes(searchText.toLowerCase())) ||
      (CompaniesData.email &&
        CompaniesData.email.toLowerCase().includes(searchText.toLowerCase())) ||
      (CompaniesData.work_number &&
        CompaniesData.work_number
          .toLowerCase()
          .includes(searchText.toLowerCase()))
      // (CompaniesData.mobile_number &&
      //   CompaniesData.mobile_number
      //     .toLowerCase()
      //     .includes(searchText.toLowerCase()))
      //     ||
      //   (CompaniesData.CREATED &&
      //     CompaniesData.CREATED.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handleExportData = () => {
    const exportedData = filteredDataCompanies.map((CompaniesData) => ({
      "COMPANY NAME": CompaniesData.company_name,
      "MASTER NO. DIOD": CompaniesData.diodid,
      "Package Name": CompaniesData.package_name,
      USER: CompaniesData.user_name,
      "EMAIL ADDRESS": CompaniesData.email,
      "WORK NUMBER": CompaniesData.work_number,
      // "MOBILE NUMBERS": CompaniesData.mobile_number,
      // Created: CompaniesData.CREATED,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," + convertToCSV(exportedData);
    const jsonData = JSON.stringify(exportedData, null, 2);

    const downloadLink = document.createElement("a");
    downloadLink.href = csvContent;
    downloadLink.download = "exported_data.csv";
    downloadLink.click();
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>

                <p>
                  Use this page to create company, add packages or add master
                  number.
                </p>
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {auth.role === "1" && (
                  <>
                    <li
                      onClick={() => navigate("/companies", { replace: true })}
                    >
                      <a href="#">Companies</a>
                    </li>
                    <li
                      onClick={() => navigate("/packages", { replace: true })}
                    >
                      <a href="#">Packages</a>
                    </li>
                    <li
                      onClick={() =>
                        navigate("/master-number", { replace: true })
                      }
                    >
                      <a href="#">Master number DIOD</a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {auth.role === "1" && (
              <>
                <li>
                  <div className="ImcomingCallMain ImcomingCallMainAdmin">
                    <div className="uk-grid" uk-grid="">
                      <div className="uk-width-1-2">
                        <div className="uk-text-left">
                          <div className="CustomSearch">
                            <form className="uk-search uk-search-default">
                              <input
                                className="uk-search-input"
                                type="text"
                                placeholder="Search by name or Diod #"
                                value={searchText}
                                onChange={handleSearchform}
                              />
                            </form>
                            {/* <div className="MainHeading">
                <h6>IVR flow</h6>
              </div> */}
                          </div>
                        </div>
                      </div>

                      <div className="uk-width-1-2">
                        <div className="uk-text-right">
                          <span>
                            <div className="uk-inline uk-text-left">
                              <Link
                                className="exportData-button NewFlow"
                                to="/add-company"
                              >
                                Add company
                              </Link>
                              <button
                                className="exportData-button"
                                onClick={handleExportData}
                              >
                                Export Data
                              </button>
                            </div>
                          </span>
                          <span className="primary-color"></span>
                        </div>
                      </div>
                    </div>

                    {loader ? (
                      <div uk-spinner="" className="tableloader"></div>
                    ) : (
                      <DataTable
                        columns={columns}
                        data={filteredDataCompanies}
                        pagination
                        customStyles={customStyles}
                        {...dataTableProps} // Spread the pagination props
                      />
                    )}
                  </div>
                </li>
                <li></li>
                <li></li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Companies;
